import {
  MonetateExperience,
} from './index.d'

export const MONETATE_URL =
  'https://engine.monetate.net/api/engine/v1/decide/JohnLewis'

export const hasKey = (exp: MonetateExperience): exp is MonetateExperience & { key: string } => {
  return exp.key !== undefined;
}
